export default function loadImageFromSrc(img: HTMLImageElement, src: string): Promise<boolean> {
    return new Promise<boolean>(resolve => {
        img.onload = e => {
            removeImageEventHandlers(img);
            resolve(true);
        };

        img.onerror = e => {
            removeImageEventHandlers(img);
            resolve(false);
        };

        img.src = src;
    });
}

function removeImageEventHandlers(img: HTMLImageElement) {
    img.onload = null;
    img.onerror = null;
}
